import React from "react";
import styled from "styled-components";

type LogoProps = {
  large?: boolean;
  isBeta?: boolean;
};

const Logo = ({ large, isBeta = false }: LogoProps) => {
  return (
    <StyledLogo large={large?.toString()}>
      links<span>ooo</span>n{isBeta && <StyledBeta>beta</StyledBeta>}
    </StyledLogo>
  );
};

const StyledLogo = styled.span<{ large?: string }>`
  position: relative;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  span {
    color: ${({ theme }) => theme.colors.primary};
  }

  ${({ large, theme }) =>
    large === "true" &&
    `
    font-size: ${theme.fontSize.LogoLarge}
  `}
`;

const StyledBeta = styled.span`
  position: absolute;
  font-size: 10px;
  top: 0;
  right: 0;
`;

export default Logo;
